import CustomStore from 'devextreme/data/custom_store'
import { DataSourceCallbacks, route } from '@/utils/index.jsx'
import links from '../links.json'

export const defaultDataSource = {
  bank: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.banks.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.banks.resource, { bank: key }))
    }
  }),

  currency: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.currencies.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.currencies.resource, { currency: key }))
    }
  }),

  postCode: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.postCodes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.postCodes.resource, { postCode: key }))
    }
  }),

  city: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.cities.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.cities.resource, { city: key }))
    }
  }),

  country: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.administration.countries.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.countries.resource, { country: key }))
    }
  }),

  responsibility_center: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.responsibilityCenters.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.responsibilityCenters.resource, { responsibilityCenter: key }))
    }
  }),

  bank_account: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.administration.bankAccounts.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.bankAccounts.resource, { bankAccount: key }))
    }
  }),

  language: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.languages.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.languages.resource, { language: key }))
    }
  }),

  unitOfMeasures: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.unitOfMeasures.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.unitOfMeasures.resource, { unitOfMeasure: key }))
    }
  }),

  measurementGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.measurementGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.measurementGroups.resource, { measurementGroup: key }))
    }
  }),

  shipmentMethod: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.shipmentMethods.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.shipmentMethods.resource, { shipmentMethod: key }))
    }
  }),

  shipmentAgent: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.shipmentAgents.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.shipmentAgents.resource, { shipmentAgent: key }))
    }
  }),

  transportMethod: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.transportMethods.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.transportMethods.resource, { transportMethod: key }))
    }
  }),

  location: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, links.administration.locations.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.locations.resource, { location: key }))
    }
  }),

  user_location: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, route(links.administration.users.locations.getGridOptions, { user: config.user.id })),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.locations.resource, { location: key }))
    }
  }),

  religion: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.religions.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.religions.resource, { religion: key }))
    }
  }),

  nationality: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.nationalities.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.nationalities.resource, { nationality: key }))
    }
  }),

  citizenship: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.citizenship.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.citizenship.resource, { citizenship: key }))
    }
  }),

  causeOfInactivity: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.causeOfInactivities.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.causeOfInactivities.resource, { causeOfInactivity: key }))
    }
  }),

  causeOfAbsence: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.causeOfAbsences.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.causeOfAbsences.resource, { causeOfAbsence: key }))
    }
  }),

  jobTitleCategory: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.jobTitleCategories.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.jobTitleCategories.resource, { jobTitleCategory: key }))
    }
  }),

  jobTitle: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.hr.jobTitles.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.jobTitles.resource, { jobTitle: key }))
    }
  }),

  organizationalStructureJobTitles: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, route(links.hr.organizationalStructureJobTitles.getOptions, {
      organizationalStructure: config.organizationalStructure ?? 0
    })),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.organizationalStructureJobTitles.resource, { $organizationalStructureJobTitle: key }))
    }
  }),

  user: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.users.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.users.resource, { user: key }))
    }
  }),

  organizationalUnit: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.organizationalUnits.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.organizationalUnits.resource, { organizationalUnit: key }))
    }
  }),

  organizationalUnitType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.organizationalUnitTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.organizationalUnitTypes.resource, { organizationalUnitType: key }))
    }
  }),

  employmentContract: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.employmentContracts.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.employmentContracts.resource, { employmentContract: key }))
    }
  }),

  measurement_group_uom: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) },
      route(links.administration.measurementGroups.measurementGroupUnitOfMeasures, {
        measurementGroupHeader: config.measurementGroupHeader.id
      })),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.unitOfMeasures.resource, { unitOfMeasure: key }))
    }
  }),

  numberingSeries: (model, paramsFromQuery) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.numberingSeries.getOptions + '?' + new URLSearchParams(paramsFromQuery).toString()),
    byKey: key => {
      if (model?.id === key) {
        return model
      }
      return DataSourceCallbacks.byKey(route(links.administration.numberingSeries.resource, { numberingSeries: key }))
    }
  }),

  account: (config = {
    type: null
  }) => new CustomStore({
    key: 'id',
    load: (options) => {
      let url = null

      if (config.type) {
        url = links.accounts.getOptions + '?' + new URLSearchParams({ type: config.type })
      } else {
        url = links.accounts.getOptions
      }

      return DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, url)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accounts.resource, { account: key }))
    }
  }),

  role: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.roles.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.roles.resource, { role: key }))
    }
  }),

  fixedAsset: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.fixedAssets.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.fixedAssets.resource, { fixedAsset: key }))
    }
  }),

  fixedAssetClass: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.fixedAssets.fixedAssetClasses.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.fixedAssets.fixedAssetClasses.resource, { fixedAssetClass: key }))
    }
  }),

  fixedAssetLocation: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.fixedAssets.fixedAssetLocations.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.fixedAssets.fixedAssetLocations.resource, { fixedAssetLocation: key }))
    }
  }),

  education: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.educations.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.educations.resource, { education: key }))
    }
  }),

  educationDegree: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.educationDegrees.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.educationDegrees.resource, { educationDegree: key }))
    }
  }),

  bachelorDegree: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.bachelorDegrees.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.bachelorDegrees.resource, { bachelorDegree: key }))
    }
  }),

  modelLifeCycle: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.modelLifeCycles.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.modelLifeCycles.resource, { modelLifeCycle: key }))
    }
  }),

  resourceGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.resources.resourceGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.resources.resourceGroups.resource, { resourceGroup: key }))
    }
  }),

  workType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.resources.workTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.resources.workTypes.resource, { workType: key }))
    }
  }),

  employee: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.hr.employees.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.employees.resource, { employee: key }))
    }
  }),

  smallInventory: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.fixedAssets.smallInventories.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.fixedAssets.smallInventories.resource, { smallInventory: key }))
    }
  }),

  resource: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.resources.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.resources.resource, { resource: key }))
    }
  }),

  resourceSkill: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.resources.resourceSkills.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.resources.resourceSkills.resource, { resourceSkill: key }))
    }
  }),

  helpTopic: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.helpDesk.helpTopics.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.helpDesk.helpTopics.resource, { helpTopic: key }))
    }
  }),

  personalTaxGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.personalTaxGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.personalTaxGroups.resource, { personalTaxGroup: key }))
    }
  }),

  personalTaxCategory: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.personalTaxCategories.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.personalTaxCategories.resource, { personalTaxCategory: key }))
    }
  }),

  company: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.administration.company.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(links.administration.company.resource)
    }
  }),

  modelLifeCyclePhase: (
    config
  ) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      options,
      route(links.administration.modelLifeCycles.phases.getOptions, { modelLifeCycle: config.modelLifeCycle.id })
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.modelLifeCycles.phases.resource, {
        modelLifeCycle: config.modelLifeCycle.id,
        modelLifeCyclePhase: key
      }))
    }
  }),

  productPostingGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.productPostingGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.productPostingGroups.resource, { productPostingGroup: key }))
    }
  }),

  payrollPostingGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.payrollPostingGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.payrollPostingGroups.resource, { payrollPostingGroup: key }))
    }
  }),

  fixedAssetPostingGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.fixedAssetPostingGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.fixedAssetPostingGroups.resource, { fixedAssetPostingGroup: key }))
    }
  }),

  zone: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.warehouses.zones.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.zones.resource, { zone: key }))
    }
  }),

  shelvingUnit: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.warehouses.shelvingUnits.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.shelvingUnits.resource, { shelvingUnit: key }))
    }
  }),

  shelf: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.warehouses.shelves.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.shelves.resource, { shelf: key }))
    }
  }),

  attributes: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.attributes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.attributes.resource, { attribute: key }))
    }
  }),

  qualificationCategory: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.qualificationCategories.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.qualificationCategories.resource, { qualificationCategory: key }))
    }
  }),

  qualification: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.qualifications.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.qualifications.resource, { qualification: key }))
    }
  }),

  organizationalStructure: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.organizationalStructures.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.organizationalStructures.resource, { organizationalStructure: key }))
    }
  }),

  transferOrder: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      route(links.warehouses.transferOrders.getOptions, { transferTypeBind: config?.transferTypeBind?.link })
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.transferOrders.resource, {
        transferTypeBind: config?.transferTypeBind?.link,
        transferOrderHeader: key
      }))
    }
  }),

  accessGroup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.accessControl.accessGroups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessGroups.resource, { accessGroup: key }))
    }
  }),

  accessDevice: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.accessControl.accessDevices.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessDevices.resource, { accessDevice: key }))
    }
  }),

  modelTermAndCondition: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.modelTermsAndConditions.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.modelTermsAndConditions.resource, { modelTermAndCondition: key }))
    }
  }),

  generalPostingSetup: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.generalPostingSetups.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.generalPostingSetups.resource, { generalPostingSetup: key }))
    }
  }),

  physicalInventory: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, links.warehouses.physicalInventories.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.physicalInventories.resource, { physicalInventoryHeader: key }))
    }
  }),

  physicalInventoryLines: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, links.warehouses.physicalInventories.lines.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.warehouses.physicalInventories.lines.resource, {
        physicalInventoryHeader: config.physicalInventoryHeader.id,
        physicalInventoryLine: key
      }))
    }
  }),

  causeOfAbsenceType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.hr.causeOfAbsenceTypes.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.causeOfAbsenceTypes.resource, { causeOfAbsenceType: key }))
    }
  }),

  weeklyOff: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.timeAttendances.weeklyOffs.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.timeAttendances.weeklyOffs.resource, { weekOff: key }))
    }
  }),

  breakTiming: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.timeAttendances.breakTimings.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.timeAttendances.breakTimings.resource, { breakTiming: key }))
    }
  }),

  groundForTermination: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.hr.groundsForTerminations.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.hr.groundsForTerminations.resource, { groundForTermination: key }))
    }
  }),

  insuranceType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.fixedAssets.insuranceTypes.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.fixedAssets.insuranceTypes.resource, { insuranceType: key }))
    }
  }),

  workShift: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.timeAttendances.workShifts.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.timeAttendances.workShifts.resource, { workShift: key }))
    }
  }),

  team: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(
      { ...options, ...(config.params ?? {}) },
      links.resources.teams.getOptions
    ),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.resources.teams.resource, { team: key }))
    }
  }),

  contractType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.contractTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.contractTypes.resource, { contractType: key }))
    }
  }),

  contractProcedureType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.administration.contractProcedureTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.contractProcedureTypes.resource, { contractProcedureType: key }))
    }
  }),

  propertyManagementEntityType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.propertyManagementSystem.propertyManagementEntityTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementEntityTypes.resource, { propertyManagementEntityType: key }))
    }
  }),

  propertyManagementUnitType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.propertyManagementSystem.propertyManagementUnitTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementUnitTypes.resource, { propertyManagementUnitType: key }))
    }
  }),

  propertyManagementUnitOwnershipType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.propertyManagementSystem.propertyManagementUnitOwnershipTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementUnitOwnershipTypes.resource, { unitOwnershipType: key }))
    }
  }),

  propertyManagementEntityBankAccount: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, route(links.propertyManagementSystem.propertyManagementEntities.bankAccounts.getOptions, {
        propertyManagementEntity: config.propertyManagementEntityId ?? 0
      }))
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementEntities.bankAccounts.resource, {
        propertyManagementEntity: config.propertyManagementEntityId,
        entityBankAccount: key
      }))
    }
  }),

  propertyManagementEntityBankAccountType: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.propertyManagementSystem.propertyManagementBankAccountTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementBankAccountTypes.resource, { bankAccountType: key }))
    }
  }),

  propertyManagementInvoiceTemplate: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(
        { ...options, ...(config.params ?? {}) },
        links.propertyManagementSystem.propertyManagementEntities.invoiceTemplatesGetOptions
      )
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementEntities.invoiceTemplatesResource, {
        entityInvoiceTemplate: key
      }))
    }
  }),

  propertyManagementSystemInvoiceTemplateTypes: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.propertyManagementSystem.invoiceTemplateTypes.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.invoiceTemplateTypes.resource, { invoiceTemplateType: key }))
    }
  }),

  accessGroupUser: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, route(links.accessControl.accessUsers.accessGroups.getOptions, { accessUser: config.accessUserId })),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessGroups.resource, { accessGroup: key }))
    }
  }),

  propertyManagementEntity: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, route(links.propertyManagementSystem.propertyManagementEntities.getOptions)),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.propertyManagementSystem.propertyManagementEntities.resource, { propertyManagementEntity: key }))
    }
  }),

  eventCategories: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.accessControl.eventCategories.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.eventCategories.resource, {
        eventCategory: key
      }))
    }
  }),

  events: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.accessControl.events.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.events.resource, {
        event: key
      }))
    }
  }),

  accessPassCategories: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.accessControl.accessPassCategories.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessPassCategories.resource, {
        accessPassCategory: key
      }))
    }
  }),

  accessReasonForVisits: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.accessControl.accessReasonForVisits.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessReasonForVisits.resource, {
        accessReasonForVisit: key
      }))
    }
  }),

  surveillancePositions: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.videoSurveillance.surveillancePositions.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.videoSurveillance.surveillancePositions.resource, {
        surveillancePosition: key
      }))
    }
  }),

  accessVisitorType: (config) => new CustomStore({
    key: 'id',
    load: (options) => {
      return DataSourceCallbacks.load(options, links.accessControl.accessVisitorTypes.getOptions)
    },
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accessControl.accessVisitorTypes.resource, {
        accessVisitorType: key
      }))
    }
  }),

  contact: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.accounts.contacts.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.accounts.contacts.resource, { contact: key }))
    }
  }),

  contract: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load(options, links.contracts.getOptions),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.contracts.resource, { contract: key }))
    }
  }),

  user_organizational_structure: (config) => new CustomStore({
    key: 'id',
    load: (options) => DataSourceCallbacks.load({ ...options, ...(config.params ?? {}) }, route(links.administration.users.organizationalStructures.getGridOptions, { user: config.user.id })),
    byKey: key => {
      if (config?.model?.id === key) {
        return config.model
      }
      return DataSourceCallbacks.byKey(route(links.administration.organizationalStructures.resource, { location: key }))
    }
  })
}
